import sanityClient from '@sanity/client'


// config file for sanity
export default sanityClient({
  projectId: "8sdfhxgz",
  dataset: "production",
});
